"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = exports.initialValues = {
  show: true,
  title: 'Facilitator Feedback Score',
  description: 'Comparison across sessions',
  chart: {
    xLabel: 'Session',
    yLabel: 'Score',
    showLegend: true,
    targetLineValue: '',
    verticalScaleMin: '0',
    verticalScaleMax: '6',
    scoreSuffix: ''
  }
};
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "show",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Facilitator Feedback Chart?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "title",
    component: _cccisdFormik.CccisdInput,
    label: "Title"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "description",
    component: _cccisdFormik.CccisdInput,
    label: "Description"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Chart Settings"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.xLabel",
    component: _cccisdFormik.CccisdInput,
    label: "X-axis Label"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.yLabel",
    component: _cccisdFormik.CccisdInput,
    label: "Y-axis Label"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.showLegend",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Legend?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.targetLineValue",
    component: _cccisdFormik.CccisdInput,
    label: "Benchmark Value",
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.verticalScaleMin",
    component: _cccisdFormik.CccisdInput,
    label: "Y-axis Min Value",
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.verticalScaleMax",
    component: _cccisdFormik.CccisdInput,
    label: "Y-axis Max Value",
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.scoreSuffix",
    component: _cccisdFormik.CccisdInput,
    label: "Y-axis Suffix"
  }));
};
var _default = exports["default"] = (0, _cccisdLaravelAppdefs.widgetBuilder)({
  initialValues: initialValues
})(Component);